export default function() {

  if ($('.generating-screens-message').length > 0) {

    // Start screens status poll if importing
    let screensStatusPoll = () => {

      // Get generating message on page
      let isGenerating = $('.generating-screens-message');

      // Only continue if status indicator present (if should poll for recs is true)
      if (isGenerating.length !== 0) {

        // Set Api url to get data
        let accountUrl = isGenerating.attr('data-account-url');
        let portfolioId = isGenerating.attr('data-portfolio-id');
        let token = isGenerating.attr('data-token');
        let params = {};
        params['portfolio_id'] = portfolioId;
        params['token'] = token;
        let url = '/' + accountUrl + '/portfolios/' + portfolioId + '/screens/check_screens_status.js?' + $.param(params);

        // Execute ajax request (using js erb template to render content so can control profile styling more easily)
        // Must specify '.js' otherwise processes as JSON
        $.ajax({
          type: "POST",
          dataType: "script",
          timeout: 3000,
          url: url,
          complete() {
            setTimeout(function() { screensStatusPoll() }, 4000);
          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    if ($('.generating-screens-message').length !== 0) { screensStatusPoll(); }

  }

}